import { render, staticRenderFns } from "./DriverDetailProfile.vue?vue&type=template&id=5d155bba&scoped=true&"
import script from "./DriverDetailProfile.vue?vue&type=script&lang=js&"
export * from "./DriverDetailProfile.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailProfile.vue?vue&type=style&index=0&id=5d155bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d155bba",
  null
  
)

export default component.exports